import React from 'react';
import { quantityConverter } from '../../common';
// Style
import './PortioningValuesBox.css';
// Assets
import CartBox from '../images/cart-box-icon.svg';

const MAX_SEPARATE_PACKAGES = 5;

const formatGrams = grams => quantityConverter(grams, 'g');

const packageDividers = count => {
  const dividerStart = `calc(100% / ${count} - 1px)`;
  const packageEnd = `calc(100% / ${count})`;
  const divider = 'rgba(255, 255, 255, 0.35)';
  return `repeating-linear-gradient(to right, transparent 0, transparent ${dividerStart}, ${divider} ${dividerStart}, ${divider} ${packageEnd})`;
};

const PortioningValuesBox = ({ quantity, portioningSize }) => {
  const portionNumber = Math.floor(quantity / portioningSize);
  if (!(portionNumber > 0)) return null;

  const remainder = quantity - portioningSize * portionNumber;
  const isGrouped =
    portionNumber + (remainder > 0 ? 1 : 0) > MAX_SEPARATE_PACKAGES;
  const portionLabel = formatGrams(portioningSize);
  const packages = isGrouped
    ? [
        {
          key: 'portions',
          size: portionNumber * portioningSize,
          label: `${portionNumber} × ${portionLabel}`,
        },
      ]
    : Array.from({ length: portionNumber }, (_, index) => ({
        key: index,
        size: portioningSize,
        label: portionLabel,
      }));

  return (
    <div className="package-info">
      <div className="package-info-header">
        <span className="package-info-title">
          <img src={CartBox} alt="" />
          Seu pedido será embalado assim
        </span>
        <span className="package-info-total">
          Total {formatGrams(quantity)}
        </span>
      </div>
      <div className="package-info-bar" aria-hidden="true">
        {packages.map(({ key, size, label }) => (
          <div
            key={key}
            className="package-info-package"
            style={{
              flexGrow: size,
              backgroundImage: isGrouped
                ? packageDividers(portionNumber)
                : undefined,
            }}
          >
            <span>{label}</span>
          </div>
        ))}
        {remainder > 0 && (
          <div
            className="package-info-package remainder"
            style={{ flexGrow: remainder }}
          >
            <span>{formatGrams(remainder)}</span>
          </div>
        )}
      </div>
      <p className="package-info-text">
        <strong>
          {portionNumber} {portionNumber === 1 ? 'embalagem' : 'embalagens'}{' '}
          de {portionLabel}
        </strong>
        {remainder > 0 &&
          ` + 1 embalagem de ${formatGrams(remainder)}`}
      </p>
    </div>
  );
};
export default PortioningValuesBox;
